import { createContext } from 'react';

export const SettingsDetailContainerContext = createContext<HTMLElement | null>(null);
